import { CustomEquipment } from '../types/sharedTypeImpl.ts';
import { CmmBadge } from './cmmBadge.tsx';

interface Props {
    machineIds: string[];
    equipments?: CustomEquipment[];
    centered?: boolean;
}

export function MachineBadges({ machineIds, equipments, centered }: Props) {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: centered ? 'center' : 'flex-start',
            flexWrap: 'wrap',
            gap: '4px',
        }}>
            {machineIds.map(id => {
                const equipment = equipments?.find(it => it._id === id);
                if (!equipment) return null;
                const badge = <CmmBadge
                    key={id}
                    displayName={equipment.displayName}
                    badgeColor={equipment.badgeColor ?? '#666666'}
                    badgeText={equipment.badgeText ?? equipment.displayName}
                />
                return badge;
            })}
        </div>
    );
}
